module.exports = __webpack_public_path__ + "static/media/contributeMobile.ab98231f.png";